import {SVGType} from '@components/SVGIcon';

export const LITERALS = {
  SUBSCRIBE_TEXT: 'SUBSCRIBE TO OUR NEWSLETTER',
  FOLLOW_TEXT: 'FOLLOW US ON',
  EMAIL_TEXT: 'EMAIL',
  PHONE_TEXT: 'PHONE',
  CONTACT_BTN_TEXT: 'Contact Us',
  COPYRIGHT_TEXT: `Copyright © ${(new Date()).getFullYear()} Aldar Properties. All Rights Reserved.`,
  CAPTCHA_TEXT:
    'This site is protected by reCAPTCHA & Google Privacy Policy & Terms of Service',
  EMAIL: 'customercare@aldar.com',
  PHONE: '800-ALDAR / 800-25327',
  CONTACT_HREF: 'https://www.aldar.com/contact-us',
};

export const SOCIALS: {iconType: SVGType; href: string}[] = [
  {
    iconType: 'facebook-svg',
    href: 'https://www.facebook.com/aldarpropertiesuae/',
  },
  {iconType: 'instagram-svg', href: 'https://www.instagram.com/aldar/'},
  {iconType: 'twitter-svg', href: 'https://twitter.com/aldar'},
  {
    iconType: 'linkedin-svg',
    href: 'https://www.linkedin.com/company/aldar-properties-pjsc',
  },
];

export const LINKS: Record<'label' | 'href', string>[] = [
  {label: 'Privacy Policy', href: 'https://www.aldar.com/privacy-policy'},
  {label: 'Terms of Use', href: 'https://www.aldar.com/terms-and-conditions'},
];
